/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateLabelRequestLabel,
  CreateLabelRequestLabelFromJSON,
  CreateLabelRequestLabelFromJSONTyped,
  CreateLabelRequestLabelToJSON
} from './CreateLabelRequestLabel'

/**
 *
 * @export
 * @interface CreateLabelRequest
 */
export interface CreateLabelRequest {
  /**
   *
   * @type {CreateLabelRequestLabel}
   * @memberof CreateLabelRequest
   */
  label?: CreateLabelRequestLabel
}

export function CreateLabelRequestFromJSON(json: any): CreateLabelRequest {
  return CreateLabelRequestFromJSONTyped(json, false)
}

export function CreateLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLabelRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    label: !exists(json, 'label') ? undefined : CreateLabelRequestLabelFromJSON(json['label'])
  }
}

export function CreateLabelRequestToJSON(value?: CreateLabelRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    label: CreateLabelRequestLabelToJSON(value.label)
  }
}
